package one.healthium.pcos.di

import org.koin.dsl.module

internal actual fun composeAppPlatformModule() = module {
}